module.exports = __webpack_public_path__ + "static/og-809acd20e77620245d40cc720d0c0688.png";